import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Card } from '@daedalus/atlas/Card';
import { NoStyleButton } from '@daedalus/atlas/helpers/NoStyleButton';
import { getLengthOfStay } from '@daedalus/core/src/utils/date';
import { Review } from '@findhotel/sapi';
import { ReviewSource } from '../../../../../shared/src/search/ReviewComment';
import { ReviewCommentWrapper } from '../ReviewCommentWrapper';
interface Props {
  review: Review;
  hasTranslationButton: boolean; // Added as part of f72fa251-guest-reviews-languages
  onReadMoreClick?: () => void;
}
const _exp = /*#__PURE__*/() => NoStyleButton;
const StyledButton = /*#__PURE__*/styled(_exp())({
  name: "StyledButton",
  class: "s1sseqad",
  propsAsIs: true
});
const ReviewContainer = /*#__PURE__*/styled('div')({
  name: "ReviewContainer",
  class: "r1hz1v1m",
  propsAsIs: false
});
export const ReviewCarouselCard = ({
  review,
  hasTranslationButton,
  onReadMoreClick
}: Props) => {
  const {
    reviewerScore,
    reviewerName,
    reviewDate,
    checkIn,
    checkOut,
    reviewSource,
    text,
    language
  } = review;
  const lengthOfStay = checkIn && checkOut && getLengthOfStay(checkIn, checkOut);
  return <StyledButton onClick={onReadMoreClick}>
      <Card borderRadius="lg" borderColorPath="border.neutral.c100">
        <ReviewContainer className={cx(hasTranslationButton && '__carouselCardWrapper')}>
          <ReviewCommentWrapper disableReadMore reviewLanguage={language} reviewText={text} reviewerScore={reviewerScore} reviewerName={reviewerName} reviewDate={reviewDate} SourceLogoSlot={reviewSource && <ReviewSource providerCode={reviewSource} />} {...lengthOfStay && {
          lengthOfStay
        }} truncatedContentLines={3} />
        </ReviewContainer>
      </Card>
    </StyledButton>;
};

require("./ReviewCarouselCard.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewCarouselCard.tsx");